import { useQuery } from '@tanstack/react-query';

// common
import useService from 'common/hook/useService';
import { handleException } from 'modules/account/detail/helpers/utils';

// screen
import type { ReplaceBusinessRegistrationCertificate } from 'modules/suppliers/types';

// export type BusinessRegistrationCertificate =
//   typeof schemas.BusinessRegistrationFromKios._type;
export type BusinessRegistrationCertificate = ReplaceBusinessRegistrationCertificate;

interface UseBusinessRegistrationCertificateProps {
  customerOperationCode?: string;
  supplierProfileOperationCode?: string;
}

const useBusinessRegistrationCertificate = (props: UseBusinessRegistrationCertificateProps) => {
  const { customerOperationCode, supplierProfileOperationCode } = props;
  const service = useService();

  return useQuery({
    queryKey: ['businessRegistrationCertificates'],
    queryFn: async () => {
      try {
        if (!service || !customerOperationCode || !supplierProfileOperationCode) {
          return null;
        }

        const res =
          await service.SupplierProfileController_listBusinessRegistrationsBySupplierProfile({
            params: {
              customerOperationCode,
              supplierProfileOperationCode,
            },
            queries: {
              supplierProfileOperationCode,
            } as { pageIndex?: number; pageSize?: number; sorts?: string },
          });

        return res;
      } catch (error) {
        handleException(error);
      }
    },
  });
};

export default useBusinessRegistrationCertificate;
